import {Injectable} from "@angular/core";
import {AbstractBaseComponent} from "../app.baseComponent";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {AuthenticationHelper} from "../helpers/authenticationHelper";
import {UtilityHelper} from "../helpers/utilityHelper";
import { shouldRedirectToWaitingListFromStorage } from "../helpers/openAccessWaitingList.helper";
import { isTransitionedFromMentorHub, readChannelDeepLink } from "../pages/gamification/experience-mode";

@Injectable()
export class MentoringGuard extends AbstractBaseComponent implements CanActivate {
    constructor(private authService: AuthenticationHelper, private utility: UtilityHelper, private route: Router) {
        super();
    }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.isLoggedIn() && (this.utility.myDomain == this.LOCAL_DOMAIN || this.utility.myDomain == this.MENTORING_DOMAIN || this.utility.myDomain == this.BRILLIANTCLUB_DOMAIN)) {
            const role = this.utility.getItem('role');
            if (role === 'mentor' && this.utility.hasMentorHubAccess) {
                const deepLink = state?.url ? readChannelDeepLink(this.route.parseUrl(state.url)) : null;
                const isOtherProject = !!deepLink && deepLink.projectId !== String(this.utility.getItem('projectId') ?? '');
                if (!isTransitionedFromMentorHub(this.utility) || isOtherProject) {
                    // Mentor Hub enters the linked project and opens the channel (MentorLayoutComponent).
                    this.route.navigate(['/mentor-hub/dashboard'], deepLink ? {
                        queryParams: {
                            project_id: deepLink.projectId,
                            channel_id: deepLink.channelId,
                            message_id: deepLink.messageId,
                        },
                    } : {});
                    return false;
                }
            }
            if (shouldRedirectToWaitingListFromStorage(this.utility)) {
                this.route.navigate(['/waiting-list']);
                return false;
            }
            return true;
        } else {
            this.route.navigate(['']);
            return false;
        }
    }
}